<template>
  <div class="prepareLessons">
    <div class="topTitle ">
      <span style="cursor: pointer;" @click="goback">返回题单</span> / {{ td }}
    </div>

    <el-row :gutter="10" style="margin-top:10px;">
      <el-col :span="16">
        <div style="background:white;padding:10px 20px 20px 20px;">
          <el-tabs v-model="activeName">
            <!-- <el-tab-pane label="题单简介" name="first">
              <el-row :gutter="20">
                <el-col :span="24">
                  <div v-html="$route.query.description"></div>
                </el-col>
              </el-row>
            </el-tab-pane> -->
            <el-tab-pane label="题目列表" name="first">
              <div v-if="isShow" style="margin-bottom: 10px;">
                <div class="clearfix">
                  <div class="fl">
                    <el-button v-if="isShowTable" type="primary" icon="el-icon-plus" @click="addList" size="mini">添加问题</el-button>
                    <el-button v-if="isShowTable" type="primary" @click="dels" size="mini">批量移除</el-button>
                  </div>
                  <div class="fr">
                    <el-button type="primary" @click="changeSoltNum" size="mini">题目排序</el-button>
                    <el-button v-if="isShowSoltNum" type="primary" @click="submitSoltNum" size="mini">确认</el-button>
                  </div>
                </div>
              </div>
              <el-table height="calc(100vh - 305px)" v-if="isShowTable" :data="tableData" size="small" stripe style="width: 100%;" :header-cell-style="{
                  background: '#f5f7fa',
                  color: '#606266',
                  'font-size': '14px',
                }" @selection-change="handleSelectionChange1">
                <el-table-column v-if="isShow" type="selection" width="55">
                </el-table-column>

                <el-table-column type="index" label="序号" width="50" align="center">
                </el-table-column>

                <el-table-column label="状态" width="50" align="center">
                  <template slot-scope="scope">
                    <svg t="1658296902087" v-if="scope.row.problemInfo.submissionInfo === 0" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13040" width="15" height="15">
                      <path d="M0 0h1024v1024H0V0z" fill="#202425" opacity=".01" p-id="13041"></path>
                      <path d="M955.733333 512c0 245.077333-198.656 443.733333-443.733333 443.733333S68.266667 757.077333 68.266667 512 266.922667 68.266667 512 68.266667s443.733333 198.656 443.733333 443.733333z" fill="#11AA66" p-id="13042"></path>
                      <path d="M512 102.4C285.7984 102.4 102.4 285.7984 102.4 512s183.3984 409.6 409.6 409.6 409.6-183.3984 409.6-409.6S738.2016 102.4 512 102.4zM34.133333 512C34.133333 248.081067 248.081067 34.133333 512 34.133333s477.866667 213.947733 477.866667 477.866667-213.947733 477.866667-477.866667 477.866667S34.133333 775.918933 34.133333 512z" fill="#11AA66" p-id="13043"></path>
                      <path d="M787.114667 339.285333a51.2 51.2 0 0 1 0 72.362667l-307.2 307.2a51.2 51.2 0 0 1-72.362667 0l-170.666667-170.666667a51.2 51.2 0 0 1 72.362667-72.362666L443.733333 610.235733l271.018667-271.018666a51.2 51.2 0 0 1 72.362667 0z" fill="#FFFFFF" p-id="13044"></path>
                    </svg>

                    <svg t="1658296992015" v-if="scope.row.problemInfo.submissionInfo === -1" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13965" width="15" height="15">
                      <path d="M827.392 195.584q65.536 65.536 97.792 147.456t32.256 167.936-32.256 167.936-97.792 147.456-147.456 98.304-167.936 32.768-168.448-32.768-147.968-98.304-98.304-147.456-32.768-167.936 32.768-167.936 98.304-147.456 147.968-97.792 168.448-32.256 167.936 32.256 147.456 97.792zM720.896 715.776q21.504-21.504 18.944-49.152t-24.064-49.152l-107.52-107.52 107.52-107.52q21.504-21.504 24.064-49.152t-18.944-49.152-51.712-21.504-51.712 21.504l-107.52 106.496-104.448-104.448q-21.504-20.48-49.152-23.04t-49.152 17.92q-21.504 21.504-21.504 52.224t21.504 52.224l104.448 104.448-104.448 104.448q-21.504 21.504-21.504 51.712t21.504 51.712 49.152 18.944 49.152-24.064l104.448-104.448 107.52 107.52q21.504 21.504 51.712 21.504t51.712-21.504z" p-id="13966" fill="#d81e06"></path>
                    </svg>

                    <div v-if="
                        scope.row.problemInfo.submissionInfo != -1 &&
                          scope.row.problemInfo.submissionInfo != 0
                      " style=" font-size: 14px;" class="el-icon-minus"></div>
                  </template>
                </el-table-column>

                <el-table-column prop="code" label="题号" width="80">
                  <template slot-scope="scope">
                    <span>
                      <el-link @click="gonext(scope.row.problemInfo)">
                        {{ scope.row.problemInfo.code }}
                      </el-link>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column prop="title" label="题目名称">
                  <template slot-scope="scope">
                    <span>
                      <el-link v-if="isShow1" @click="gonext(scope.row.problemInfo)">{{ scope.row.problemInfo.title }}</el-link>
                      <span v-else>{{ scope.row.problemInfo.title }}</span>
                    </span>
                  </template>
                </el-table-column>

                <el-table-column label="难度" width="80">
                  <template slot-scope="scope">
                    <span>
                      {{ scope.row.problemInfo.difficultyTitle }}
                    </span>
                  </template>
                </el-table-column>

                <el-table-column label="来源" width="80">
                  <template slot-scope="scope">
                    <span>
                      {{ scope.row.problemInfo.sourceTitle }}
                    </span>
                  </template>
                </el-table-column>

                <el-table-column prop="" label="操作" v-if="isShow" width="100">
                  <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="del(scope.row.problemInfo)">移除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div v-if="isShowTable" style="margin: 20px; text-align: right">
                <el-pagination @current-change="handleCurrent" :current-page="page_no" :page-size="page_size" layout="total, prev, pager, next, jumper" :total="total">
                </el-pagination>
              </div>
              <div v-if="isShowSoltNum" class="TableSolt">
                <el-table height="calc(100vh - 283px)" row-key="id" :data="tableDataSolt" tooltip-effect="dark" size="mini" stripe style="width: 100%;" :header-cell-style="{
                    color: '#909399',
                    background: '#f5f7fa',
                  }">
                  <el-table-column type="index" align="center" label="序号" width="40">
                  </el-table-column>

                  <el-table-column label="状态" width="50" align="center">
                    <template slot-scope="scope">
                      <svg t="1658296902087" v-if="scope.row.problemInfo.submissionInfo === 0" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13040" width="15" height="15">
                        <path d="M0 0h1024v1024H0V0z" fill="#202425" opacity=".01" p-id="13041"></path>
                        <path d="M955.733333 512c0 245.077333-198.656 443.733333-443.733333 443.733333S68.266667 757.077333 68.266667 512 266.922667 68.266667 512 68.266667s443.733333 198.656 443.733333 443.733333z" fill="#11AA66" p-id="13042"></path>
                        <path d="M512 102.4C285.7984 102.4 102.4 285.7984 102.4 512s183.3984 409.6 409.6 409.6 409.6-183.3984 409.6-409.6S738.2016 102.4 512 102.4zM34.133333 512C34.133333 248.081067 248.081067 34.133333 512 34.133333s477.866667 213.947733 477.866667 477.866667-213.947733 477.866667-477.866667 477.866667S34.133333 775.918933 34.133333 512z" fill="#11AA66" p-id="13043"></path>
                        <path d="M787.114667 339.285333a51.2 51.2 0 0 1 0 72.362667l-307.2 307.2a51.2 51.2 0 0 1-72.362667 0l-170.666667-170.666667a51.2 51.2 0 0 1 72.362667-72.362666L443.733333 610.235733l271.018667-271.018666a51.2 51.2 0 0 1 72.362667 0z" fill="#FFFFFF" p-id="13044"></path>
                      </svg>

                      <svg t="1658296992015" v-if="scope.row.problemInfo.submissionInfo === -1" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13965" width="15" height="15">
                        <path d="M827.392 195.584q65.536 65.536 97.792 147.456t32.256 167.936-32.256 167.936-97.792 147.456-147.456 98.304-167.936 32.768-168.448-32.768-147.968-98.304-98.304-147.456-32.768-167.936 32.768-167.936 98.304-147.456 147.968-97.792 168.448-32.256 167.936 32.256 147.456 97.792zM720.896 715.776q21.504-21.504 18.944-49.152t-24.064-49.152l-107.52-107.52 107.52-107.52q21.504-21.504 24.064-49.152t-18.944-49.152-51.712-21.504-51.712 21.504l-107.52 106.496-104.448-104.448q-21.504-20.48-49.152-23.04t-49.152 17.92q-21.504 21.504-21.504 52.224t21.504 52.224l104.448 104.448-104.448 104.448q-21.504 21.504-21.504 51.712t21.504 51.712 49.152 18.944 49.152-24.064l104.448-104.448 107.52 107.52q21.504 21.504 51.712 21.504t51.712-21.504z" p-id="13966" fill="#d81e06"></path>
                      </svg>

                      <div v-if="
                          scope.row.problemInfo.submissionInfo != -1 &&
                            scope.row.problemInfo.submissionInfo != 0
                        " style=" font-size: 14px;" class="el-icon-minus"></div>
                    </template>
                  </el-table-column>

                  <el-table-column prop="code" label="题号">
                    <template slot-scope="scope">
                      <span>
                        <span>{{ scope.row.problemInfo.code }}</span>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="title" label="题目名称">
                    <template slot-scope="scope">
                      <span>
                        <el-link v-if="isShow1" @click="gonext(scope.row.problemInfo)">{{ scope.row.problemInfo.title }}</el-link>
                        <span v-else>{{ scope.row.problemInfo.title }}</span>
                      </span>
                    </template>
                  </el-table-column>

                  <el-table-column label="难度" width="80">
                    <template slot-scope="scope">
                      <span>
                        {{ scope.row.problemInfo.difficultyTitle }}
                      </span>
                    </template>
                  </el-table-column>

                  <el-table-column label="来源" width="80">
                    <template slot-scope="scope">
                      <span>
                        {{ scope.row.problemInfo.sourceTitle }}
                      </span>
                    </template>
                  </el-table-column>

                  <el-table-column prop="" label="操作" v-if="isShow" width="100">
                    <template slot-scope="">
                      <i class="el-icon-rank" style="margin-left:20px; cursor: pointer;"></i>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-col>
      <el-col :span="8">
        <div style="background:white;">
          <div class="briefIntroduction_right">
            <ul>
              <li class="clearfix">
                <div class="fl">题单类型</div>
                <div class="fr">
                  <span v-if="$route.query.educational != null">校区题单</span>
                  <span v-else>平台题单</span>
                </div>
              </li>
            </ul>
          </div>

          <div class="briefIntroduction_right_bottom" style="margin-top:0px;" v-if="$route.query.type === 'my' ? false : true">
            <span style="font-weight: bold;font-size: 18px;">我通过的题目</span>
            <div style="margin-top:10px">
              <el-progress :percentage="this.num"></el-progress>
            </div>
          </div>
        </div>
        <div class="briefIntroduction_right" style="margin-top:10px;height: calc(100vh - 314px);overflow-y: auto; box-sizing: border-box;">
          <ul>
            <li class="clearfix">
              <div class="fl">题单简介</div>
              <svg t="1658393812149" @click="addProblem" v-if="isShow" style="float:right;cursor:pointer;" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8974" width="20" height="20">
                <path d="M857.4 722.7c-4 84-73.5 151.2-158.3 151.2H324.8c-84.8 0-154.3-67.1-158.3-151.2h-0.2V299.3h0.2c4-84.1 73.5-151.3 158.3-151.3H640l-68.3 57.7H324.8C269.3 205.9 224 251.3 224 307v408c0 55.7 45.3 101.1 100.8 101.1H699.1c55.6 0 100.8-45.4 100.8-101.1V429.5l57.6-56.8v350h-0.1zM658.4 469l-41.8 44.1c-13.9 14.2-48.9 49.7-60 61.5-11.1 11.8-20.4 21.5-27.6 29.2-7.3 7.6-11.7 12-13 13.1-3.5 3.2-7.5 6.7-12 10.3-4.5 3.6-9.2 6.5-14.1 8.7-4.9 2.6-12 5.6-21.4 9.3-9.4 3.6-19.2 7.1-29.5 10.6s-20 6.4-29.2 9c-9.2 2.5-16.1 4.2-20.6 4.9-9.4 1.1-15.6-0.4-18.8-4.4-3.1-4-4-10.8-2.6-20.1 0.7-5.1 2.4-12.5 5-22.1 2.6-9.6 5.4-19.6 8.3-30 3-10.3 5.8-19.9 8.6-28.6 2.8-8.7 5-14.7 6.8-18 2.1-5 4.4-9.7 7.1-13.9 2.6-4.2 6.3-8.8 11.2-13.9 2.1-2.2 7-7.4 14.6-15.5 7.6-8.2 39.7-40.8 51.2-52.8l38.1-39.8 42.3-44.1 108-112.8 98.4 99.8-109 115.5z m176.5-186c-5.2 5.4-9.8 10.2-14 14.2-4.1 4.1-7.7 7.7-10.7 10.8-3.5 3.6-6.7 6.8-9.7 9.5l-97.9-99.8c5.2-5 11.4-11 18.5-18s13.1-12.5 17.9-16.6c6.1-5 12.4-8.5 18.9-10.5 6-1.9 11.8-2.8 17.6-2.7h1.6c3.2 0.1 6.3 0.4 9.4 1h-0.3 0.3c13.2 2.5 27 9.6 38.7 20.9 6.5 6.3 11.8 13.4 15.6 20.6 5.7 10.7 8.4 21.9 7.8 32.1 0 1.2 0.1 2.5 0.1 3.8 0 5.9-1.1 11.8-3.3 17.7-2.2 5.9-5.7 11.6-10.5 17z m0 0" p-id="8975" fill="#515151"></path>
              </svg>
            </li>
            <li>
              <div v-html="addForm.description"></div>
            </li>
          </ul>
        </div>
      </el-col>
    </el-row>

    <el-drawer title="题单简介" style="border-color:transparent" size="50%" :visible.sync="drawer" direction="rtl">
      <Tinymce v-model="content"></Tinymce>
    </el-drawer>
    <el-dialog title="添加题目" :visible.sync="dialogVisible" width="80%" top="5vh">
      <el-form ref="form" :inline="true" :model="form" size="mini">
        <el-form-item label="标题">
          <el-input v-model="form.title_code" style="width:300px" placeholder="请输入标题" clearable></el-input>
        </el-form-item>
        <el-form-item label="题目所属">
          <el-select v-model="form.resource" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option label="平台" value="1"></el-option>
            <el-option label="校区" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="按知识点筛选">
          <el-cascader @change="changeKonw" style="width: 230px;" v-model="form.Know" :props="Konwprops" :options="KnowledgeList" collapse-tags clearable></el-cascader>
        </el-form-item>
        <el-form-item label="按难度筛选">
          <el-select style="width: 230px;" multiple collapse-tags v-model="form.conditions" placeholder="请选择" clearable>
            <el-option v-for="item in conditionList" :key="item.id" :label="item.title" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="按来源筛选">
          <el-select style="width: 230px;" multiple collapse-tags v-model="form.source" placeholder="请选择" clearable>
            <el-option v-for="item in sourceList" :key="item.id" :label="item.title" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search" icon="el-icon-search" size="mini">查询
          </el-button>
        </el-form-item>
      </el-form>

      <el-table height="45vh" ref="ListTable" :data="tableData1" :row-key="
          (row) => {
            return row.id;
          }
        " stripe style="width: 100%;" :header-cell-style="{ background: '#f5f7fa' }" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" :reserve-selection="true">
        </el-table-column>
        <el-table-column prop="code" label="题号"> </el-table-column>
        <el-table-column prop="title" label="标题"> </el-table-column>
        <el-table-column label="标签">
          <template slot-scope="scope">
            <span v-for="item in scope.row.problemTagArr" :key="item.id">
              {{ item.tagInfo.title }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="difficultyTitle" label="难度" width="80"> </el-table-column>
        <el-table-column prop="sourceTitle" label="来源" width="80"> </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
      <div style="margin: 20px; text-align: right">
        <el-pagination @current-change="handleCurrent1" :current-page="page_no1" :page-size="page_size1" layout="total, prev, pager, next, jumper" :total="total1">
        </el-pagination>
      </div>
    </el-dialog>
    <el-dialog title="新增题单" :visible.sync="dialogVisible1" width="80%">
      <el-form ref="addForm" :model="addForm" label-width="80px" :rules="rules">
        <el-form-item label="排序号" prop="sort_num" required>
          <el-input-number v-model="addForm.sort_num" :precision="1" :step="0.1"></el-input-number>
        </el-form-item>
        <el-form-item label="是否发布">
          <el-select v-model="addForm.post_state" placeholder="请选择活动区域">
            <el-option label="启用" value="1"></el-option>
            <el-option label="停用" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="题单名称" prop="title" required>
          <el-input v-model="addForm.title" placeholder="请输入题单名称" maxlength="200" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="题单描述" prop="description" required>
          <!-- <el-input type="textarea" v-model="addForm.description" maxlength="500" show-word-limit></el-input> -->
          <Tinymce v-model="addForm.description"></Tinymce>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close('addForm')">取 消</el-button>
        <el-button type="primary" @click="submit1('addForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Tinymce from "@/components/Tinymce";
import Sortable from "sortablejs";

import {
  tchGetOjProblemListForProblemList,
  tchAddProblemForProblemList,
  getProblemForProblemList,
  tchDeleteProblemForProblemList,
  tchAddOrUpdateOjProblemList,
  getOjProblemDifficultyList, //按难度筛选
  getOjProblemTagGroupList, //知识点
  getOjProblemSourceList, //来源
  getProblemForProblemListSort,
  tchUpdateProblemSortOfPorblemList,
} from "@/api/educational.js";

export default {
  components: {
    Tinymce,
  },
  data() {
    return {
      soltIds: [],
      //题目排序
      tableDataSolt: [],
      //题单
      isShowSoltNum: false,
      isShowTable: true,

      //来源
      sourceList: [],
      //知识点
      KnowledgeList: [],
      Konwprops: {
        value: "id",
        label: "title",
        children: "tagArrInfo",
        multiple: true,
      },
      //难度
      conditionList: [],
      //
      td: "",
      miaos: "",
      dialogVisible1: false,
      addForm: {
        post_state: "",
        sort_num: 0,
        title: "",
      },
      num: 0,
      isShow1: false,
      isShow: false,
      //
      form: {
        conditions: [],
        Know: [],
        source: [],
        Know1: [],
        resource: "",
      },
      problemlist_id: "",
      page_no1: 1,
      page_size1: 20,
      total1: 20,
      tableData1: [],
      dialogVisible: false,
      content: "",
      drawer: false,
      page_no: 1,
      page_size: 20,
      total: 20,
      activeName: "first",
      tableData: [],
      multipleSelection: [],
      multipleSelection1: [],
      rules: {
        title: [
          {
            required: true,
            message: "请输入标签名称",
            trigger: "change",
          },
          {
            required: true,
            message: "请输入标签名称",
            trigger: "blur",
          },
        ],
        sort_num: [
          {
            required: true,
            message: "请输入排序号",
            trigger: "change",
          },
          {
            required: true,
            message: "请输入排序号",
            trigger: "blur",
          },
        ],

        description: [
          {
            required: true,
            message: "请输入题单描述",
            trigger: "change",
          },
          {
            required: true,
            message: "请输入题单描述",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.addForm.sort_num = this.$route.query.sort_num;
    this.addForm.post_state = this.$route.query.post_state;

    this.addForm.description = this.$route.query.description;
    this.addForm.title = this.$route.query.title;

    if (this.$route.query.practice) {
      this.isShow = false;
      this.isShow1 = true;
    } else {
      this.isShow = true;
      this.isShow1 = false;
    }
  },
  mounted() {
    this.problemlist_id = this.$route.query.problemlist_id;
    console.log(this.$route.query.problemlist_id, 586532);

    this.td = sessionStorage.getItem("Ojtd");
    console.log(this.td, 856523);
    this.getProblemForProblemList();
    this.setItemProgress();
    this.getOjProblemDifficultyList(); //按难度筛选
    this.getOjProblemTagGroupList(); //知识点
    this.getOjProblemSourceList(); //来源
  },

  methods: {
    // 行拖拽
    rowDrop() {
      // 要侦听拖拽响应的DOM对象
      const tbody = document.querySelector(
        ".TableSolt .el-table__body-wrapper tbody"
      );
      const that = this;
      console.log(that.tableDataSolt, 4547878);

      Sortable.create(tbody, {
        animation: 1000,
        ghostClass: "ghostClass", //设置拖拽停靠样式类名
        chosenClass: "chosenClass", //设置选中样式类名
        handle: ".el-icon-rank",
        // 结束拖拽后的回调函数
        onEnd({ newIndex, oldIndex }) {
          console.log("拖动了行，当前序号：" + newIndex);
          const currentRow = that.tableDataSolt.splice(oldIndex, 1)[0];
          that.tableDataSolt.splice(newIndex, 0, currentRow);
          console.log(that.tableDataSolt, 4578);
        },
      });
    },
    //排序
    getProblemForProblemListSort() {
      getProblemForProblemListSort({
        problemlist_id: this.problemlist_id,
      }).then((res) => {
        console.log(res);
        this.tableDataSolt = res.problemListRelationList;
      });
    },
    //排序
    changeSoltNum() {
      this.getProblemForProblemListSort();

      console.log(12121);
      this.isShowTable = false;
      this.isShowSoltNum = true;
      this.$nextTick(() => {
        this.rowDrop();
      });
    },
    submitSoltNum() {
      this.soltIds = [];
      this.tableDataSolt.map((item) => {
        this.soltIds.push(item.id);
      });
      console.log(this.soltIds, 7777888);
      tchUpdateProblemSortOfPorblemList({
        problemListRelationArr: JSON.stringify(this.soltIds),
      }).then((res) => {
        console.log(res);
        this.getProblemForProblemList();

        this.$message.success("修改成功");
      });
      this.isShowTable = true;
      this.isShowSoltNum = false;
    },

    //查询
    //难度
    getOjProblemDifficultyList() {
      getOjProblemDifficultyList({}).then((res) => {
        this.conditionList = res.ojProblemDifficultyList;
      });
    },
    //知识点
    getOjProblemTagGroupList() {
      getOjProblemTagGroupList().then((res) => {
        this.KnowledgeList = res.ojProblemTagGroupList;
        console.log(res, 5653232);
      });
    },
    changeKonw(val) {
      this.form.Know1 = [];
      val.map((item) => {
        this.form.Know1.push(item[1]);
      });
      console.log(this.form.Know1, 452121);
    },
    //来源
    // sourceList
    getOjProblemSourceList() {
      getOjProblemSourceList({}).then((res) => {
        console.log(res);
        this.sourceList = res.ojProblemSourceList;
      });
    },

    search() {
      this.page_no1 = 1;
      this.tchGetOjProblemListForProblemList();
    },
    addProblem() {
      this.dialogVisible1 = true;
    },
    //关闭
    close() {
      // this.$refs["addForm"].resetFields();
      this.dialogVisible1 = false;
    },
    submit1(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(123, 45);
          tchAddOrUpdateOjProblemList({
            id: this.$route.query.problemlist_id,
            ...this.addForm,
          }).then(() => {
            this.miaos = this.addForm.description;
            console.log(this.miaos, 123465);

            this.$message.success("修改成功!");
            this.close();
          });
        }
      });
    },
    // $route.query.problem_num/$route.query.problemAcceptNum
    setItemProgress() {
      if (this.$route.query.problemAcceptNum > this.$route.query.problem_num) {
        return 100;
      } else {
        this.num =
          (
            this.$route.query.problemAcceptNum / this.$route.query.problem_num
          ).toFixed(2) * 100;
        console.log(
          parseInt(
            (
              this.$route.query.problemAcceptNum / this.$route.query.problem_num
            ).toFixed(1) * 100
          ),
          222222222
        );
        return parseInt(
          (
            this.$route.query.problemAcceptNum / this.$route.query.problem_num
          ).toFixed(1) * 100
        );
      }
    },
    // setItemText() {
    //   return () => {
    //     return + this.$route.query.problemAcceptNum + ' / ' + this.$route.query.problem_num
    //   }
    // },
    gonext(row) {
      console.log(this.problemlist_id, 586532);
      this.$router.push({
        name: "questionBankDetails",
        query: {
          id: row.id,
          type1: "tidan",
          description: this.$route.query.description,
          problemlist_id: this.$route.query.problemlist_id,
          practice: "practice",
          title: this.$route.query.title,
          code: this.$route.query.code,
          problemAcceptNum: this.$route.query.problemAcceptNum,
          problem_num: this.$route.query.problem_num,
        },
      });
    },
    dels() {
      if (this.multipleSelection1.length === 0) {
        this.$message.warning("请选中再进行移除!");
        return false;
      }

      this.$confirm("是否确认移除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          tchDeleteProblemForProblemList({
            problemlist_id: this.problemlist_id,
            problemIds: JSON.stringify(this.multipleSelection1),
          }).then(() => {
            this.$message({
              type: "success",
              message: "移除成功!",
            });
            this.getProblemForProblemList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消移除",
          });
        });
    },
    handleSelectionChange1(val) {
      console.log(val);
      let arr1 = [];
      this.multipleSelection1 = [];
      for (let k = 0; k < val.length; k++) {
        console.log(val[k], 5652323);
        arr1.push(val[k].problemInfo.id);
        console.log(arr1);
        this.multipleSelection1 = arr1;
      }
      console.log(this.multipleSelection1);
    },
    del(row) {
      console.log(row.id);
      let ids = [];
      ids.push(row.id);
      this.$confirm("是否确认删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          tchDeleteProblemForProblemList({
            problemlist_id: this.problemlist_id,
            problemIds: JSON.stringify(ids),
          }).then(() => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getProblemForProblemList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    getProblemForProblemList() {
      getProblemForProblemList({
        problemlist_id: this.problemlist_id,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log(res);
        this.tableData = res.problemListRelationList;
        this.total = res.total;
      });
    },
    peactic() {
      console.log(123);
    },
    submit() {
      tchAddProblemForProblemList({
        problemlist_id: this.problemlist_id,
        problemIds: JSON.stringify(this.multipleSelection),
      }).then((res) => {
        console.log(res);
        this.$message.success("添加成功!");
        this.dialogVisible = false;
        this.getProblemForProblemList();
      });
    },
    handleSelectionChange(val) {
      console.log(val);
      let arr = [];
      this.multipleSelection = [];
      for (let k = 0; k < val.length; k++) {
        arr.push(val[k].id);
        console.log(arr);
        this.multipleSelection = arr;
      }
      console.log(this.multipleSelection);
    },
    addList() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.ListTable.clearSelection();
      });
      this.page_no1 = 1;
      this.tchGetOjProblemListForProblemList();
    },

    tchGetOjProblemListForProblemList() {
      tchGetOjProblemListForProblemList({
        // title_code:
        // ...this.form,
        difficultyIdArr: JSON.stringify(this.form.conditions),
        tagIdArr: JSON.stringify(this.form.Know1),
        sourceIdArr: JSON.stringify(this.form.source),
        isPlatform: this.form.resource,
        title_code: this.form.title_code,
        problemlist_id: this.problemlist_id,
        page_no: this.page_no1,
        page_size: this.page_size1,
      }).then((res) => {
        console.log(res);
        this.tableData1 = res.ojProblemList;
        this.total1 = res.total;
      });
    },
    edit() {
      this.drawer = true;
    },
    handleCurrent(val) {
      this.page_no = val;
      this.getProblemForProblemList();
    },
    handleCurrent1(val) {
      this.page_no1 = val;
      this.tchGetOjProblemListForProblemList();
    },
    goback() {
      if (this.$route.query.type === "my") {
        this.$router.push({
          name: "MyListOfUestions",
        });
      } else {
        this.$router.push({
          name: "ListOfUestions",
        });
      }

      // this.$router.go(-1)
    },
  },
};
</script>

<style lang="scss" scoped>
.prepareLessons {
  margin: 10px;
  min-height: calc(100vh - 120px);
  /* background: #fff; */
  border-radius: 5px;
  overflow: hidden;
}

.briefIntroduction_right {
  padding: 20px;
  padding-top: 0px;
  background: white;
  border-radius: 5px;
  overflow: hidden;
}

.briefIntroduction_right li {
  margin-top: 20px;
  font-size: 16px;
  font-weight: 500;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.clearfix:after {
  content: "";
  display: block;
  visibility: hidden;
  clear: both;
}

.briefIntroduction_right_bottom {
  padding: 20px;
  background: white;

  border-radius: 5px;
  overflow: hidden;
}

.topTitle {
  height: 60px;
  background: #fff;

  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;

  span {
    color: rgba(0, 0, 0, 0.45);
  }
}

.mian {
  margin-top: 10px;
  padding: 20px;
  min-height: 100vh;
  background: #fff;
  box-sizing: border-box;
}

::v-deep .el-drawer__header > :first-child {
  outline: none;
}

// 对话框圆角
/deep/ .el-dialog {
  border-radius: 10px;
}
</style>
